
import Vue from 'vue'

export default Vue.extend({
  name: 'HistorySvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
